import { render } from "./HouseNumberInput.vue?vue&type=template&id=0bc649fd&scoped=true"
import script from "./HouseNumberInput.vue?vue&type=script&lang=js"
export * from "./HouseNumberInput.vue?vue&type=script&lang=js"

import "./HouseNumberInput.vue?vue&type=style&index=0&id=0bc649fd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc649fd"]])

export default __exports__